(ns app.service.spreadsheet.model
  (:require [schema.core :as s]))

(def file-formats [:csv :xlsx])

(s/defschema SpreadsheetFileFormat (apply s/enum file-formats))

(def xlsx-content-type "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")

(defn format->content-type [format]
  (case format
    :csv  "text/csv; charset=utf-8"
    :xlsx xlsx-content-type
    xlsx-content-type))

(defn format->extension [format]
  (case format
    :csv  ".csv"
    :xlsx ".xlsx"
    ".xlsx"))
